import { useEffect, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import FormBuildTabs from "../../plugins/formBuilder/FormBuildTabs";

const SplitLoad = ({ childLoad }: any) => {
  console.log(childLoad);
  const [changeSplite, setChangeSplite] = useState(false);
  const [crudOp, setCrudOP] = useState({});
  const { res, mutate, isPending } = useAxios({
    url: "/api/auth/form",
  });

  useEffect(() => {
    setChangeSplite(true);
    mutate({ formId: "loadsplit" });
  }, []);

  return (
    <>
      <div className="h-10 border-b border-green-600 rounded-xl"></div>
      <div className="p-3">
        <h2 className="text-green-600 font-medium">Split Load</h2>
      </div>
      <div className="h-10 border-t border-green-600 rounded-xl"></div>
      {childLoad?.map((items: any, index: number) => {
        return (
          <FormBuildTabs
            getformData={res?.data?.data}
            source={{ load_id: items?.id }}
            openlist={""}
            crudOp={{ action: "view", id: items?.id }}
          />
        );
      })}
    </>
  );
};

export default SplitLoad;
